import { Component, Input, OnInit } from '@angular/core';

import { HisAuthService, HisUiService, HisNavigationService } from 'hisng';
import { ResearchInfrastructure } from '../../../model/research-infrastructure';

@Component( {
    selector: 'res-infrastructure-view-vcard',
    templateUrl: './research-infrastructure-view-vcard.component.html',
    preserveWhitespaces: false
} )
export class ResearchInfrastructureViewVCardComponent implements OnInit {
    @Input() researchInfrastructure: ResearchInfrastructure = new ResearchInfrastructure();
    public dateFormat: string; // dateFormat for date pipe
    public localizedShorttext: string; // project's shorttext in current language
    public actualDate: Date = new Date();

    constructor(public auth: HisAuthService,
        private hisUiService: HisUiService,
        private navigationService: HisNavigationService) {
    }
    /* Component ngOnInt() */
    ngOnInit() {
        // get dateFormat for date pipe from locale
        this.dateFormat = this.hisUiService.translate('common.dateFormat');
    }

    capitalizeInitialLetter( text: string): string {
        if(text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }
        return '';
    }
}
